/**
 * lodash配置文件
 *
 * @date 2019-04-29
 * @author chenyongzheng
 */

// 引入vue
import Vue from 'vue';

// 引入lodash
import lodash from 'lodash';

// 挂载到 Vue原型链
Vue.prototype.$lodash = lodash;



// WEBPACK FOOTER //
// ./src/utils/lodash.js